module.exports = __webpack_public_path__ + "img/f280-heating.f843b01e.jpg";